import React, { useState, useEffect, useContext } from "react";
import { Store } from "react-notifications-component";
import { Row, Col, Tabs, Card, Button, Tab } from "react-bootstrap";
import axios from "axios";
import { AutoComplete, Divider } from "rsuite";
import InputText from "../Elements/InputText.jsx";
import InputPassword from "../Elements/InputPassword.jsx";
import InputSelect from "../Elements/InputSelect.jsx";
import classes from "./NewUser.module.css";
import NewUser from "./NewUser";
import NewCustomer from "./NewCustomer";
import PermissionContext from "../../Store/permission-context";
var CryptoJS = require("crypto-js");
const NewRegistration = () => {
  const [Username, setUsername] = useState("");
  const [Surname, setSurname] = useState("");
  const [Firstname, setFirstname] = useState("");
  const [Middlename, setMiddlename] = useState("");
  const PCtx = useContext(PermissionContext);
  const [Gateway, setGateway] = useState("");
  const [RetypeGateway, setRetypeGateway] = useState("");
  const [Address, setAddress] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [Email, setEmail] = useState("");
  const [Category, setCategory] = useState("");
  const [AllUsers, setAllUsers] = useState("");
  const [AxiosError, setAxiosError] = useState("");
  const Path = PCtx.ThePath;

  useEffect(() => {
    const getData = async () => {
      let Users = await PCtx.connectAxios("getallusers.php", "");
      setAllUsers(Users);
    };
    getData();
  }, []);

  const RegisterStaff = async (e) => {
    e.preventDefault();
    if (!AllUsers.includes(Username)) {
      if (Gateway === RetypeGateway) {
        var scrambled = CryptoJS.AES.encrypt(
          Gateway,
          "143tonybridget",
        ).toString();

        //To decrypt
        // var bytes = CryptoJS.AES.decrypt(ciphertext, "143tonybridget");
        // var decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        // console.log(decryptedData);

        let staff = {
          Username: Username,
          Surname: Surname,
          Firstname: Firstname,
          Middlename: Middlename,
          Gateway: scrambled,
          Address: Address,
          PhoneNumber: PhoneNumber,
          Email: Email,
          Category: Category,
        };

        let Response = await PCtx.connectAxios("savenewstaff.php", staff);
        if (Response.includes("Success")) {
          PCtx.displayAlert(
            "SUCCESS",
            "registered successfully. You can start using the software by login in with your Username and Password",
            "success",
          );
          window.location.href = "/" + Path;
        }
      } else {
        PCtx.displayAlert(
          "ERROR",
          "The two password does not match. Please enter the same value in the Password and Retype Password fields",
          "danger",
        );
      }
    } else {
      PCtx.displayAlert(
        "ERROR",
        "Ooops! " +
          Username +
          " is already existing. Please Choose another Username",
        "danger",
      );
    }
  };
  return (
    <Row>
      <Col md={12}>
        <Card>
          <Card.Body>
            <h5
              className="text-center "
              style={{ color: "brown", fontFamily: "Times New Roman" }}
            >
              <Divider className="m-0">REGISTRATION FORMS</Divider>
            </h5>
          </Card.Body>
        </Card>
      </Col>
      <Col md={12} sm={12} xs={12}>
        <Tabs
          defaultActiveKey="newstaff"
          id="uncontrolled-tab-example"
          className={`${classes.hide4printing} ${"mb-3"}`}
          style={{ border: "1px brown solid" }}
        >
          <Tab
            eventKey="newstaff"
            title="NEW STAFF FORM"
            className={classes.margin4printing}
          >
            <NewUser />
          </Tab>
          <Tab
            eventKey="newcustomer"
            title="NEW CUSTOMER FORM"
            className={classes.margin4printing}
          >
            <NewCustomer />
          </Tab>
        </Tabs>
      </Col>
    </Row>
  );
};

export default NewRegistration;
